export default __webpack_public_path__ + "static/media/US_flag.449bbbc0.jpg";